import { FC } from 'react';
import { AdvertServiceDataType, useBotDetectorContext } from '@edikk-edikk/country-frontend';
import advertDetailServiceCss from '../../assets/service/service.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  price: AdvertServiceDataType['price'];
};

const ServicePrice: FC<PropsType> = ({
  price,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (!price) {
    return null;
  }

  return (
    <span className={advertDetailServiceCss.advertDetailService__price}>
      (+
      {price}
      )
    </span>
  );
};

export { ServicePrice };
